import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(50 - Math.random() * 10);
  const [index, setIndex] = useState(1);
  const toRotate = ["Web Developer", "Web Designer", "Software Engineer"];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text, delta]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 1.5);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(50);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <div className="banner-content">
              <span className="tagline"></span>
              <h1>{`Hey there, I'm Tristan`}<br></br> <span className="txt-rotate" dataPeriod="1000" data-rotate={JSON.stringify(toRotate)}><span className="wrap">{text}</span></span></h1>
              <p>A down-to-earth web developer with a passion for turning ideas into digital reality. I speak the languages of the web, including JavaScript, C#, HTML, and CSS. Whether it's building clean and functional interfaces or diving into the nitty-gritty of backend logic, I've got it covered.

              I specialize in React, bringing that extra touch to make websites not just work, but work seamlessly. Git is my go-to for version control, ensuring smooth collaboration and project management.

              I believe in the power of clean code and problem-solving. Staying on top of the latest tech trends is my thing, and I'm always keen to explore new technologies to improve my craft.

              Outside of coding, you'll find me exploring the latest web development frameworks, contributing to open-source projects, and just enjoying the journey of continuous learning. Let's build something awesome!</p>
              <a className="btnlink" href="#connect">
                <button onClick={() => console.log('connect')}>Let’s Connect <ArrowRightCircle size={25} /></button>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

